<div class="container mx-auto px-4 md:px-8 py-12 mt-16 max-w-4xl">
  <div class="text-center mb-12 sm:mb-16 relative">
    <h2 class="text-2xl sm:text-3xl font-extrabold text-gray-800">
      CleverDeals – A Better & Cheaper Alternative to KickStarter and IndiGoGo for Your Product Launch
    </h2>
    <div class="w-16 sm:w-20 h-1 bg-gradient-to-r from-[#F9CC0B] to-[#FFE97F] mx-auto mt-2 rounded-full"></div>
    <img src="assets/images/kickstart.jpg" alt="Kickstarter Alternative"
      class="mx-auto mt-4 w-full max-h-[60vh] object-cover rounded-xl" />
  </div>

  <div class="terms-content text-gray-700 leading-relaxed text-justify">

    <p>
      In a world where the web is filled with fluffy AI generated slop, we think
      it is best to keep our messaging clear and precise, so here are the
      reasons to use CleverDeals instead of KickStarter:
    </p>

    <section class="mt-8">
      <div class="flex flex-col md:flex-row items-center md:items-start gap-8">
        <div class="md:w-1/2 text-center md:text-left">
          <i class="fa-solid fa-dollar-sign text-4xl text-yellow-500 mb-4"></i>
          <h3 class="text-xl font-semibold mb-2">Cost</h3>
          <p class="text-gray-700">
            CleverDeals charges only 5% – a much better deal than KickStarter.
            You’re doing this to raise money for your project — you keep more of it with us.
          </p>
        </div>
      </div>

      <div class="flex flex-col md:flex-row-reverse items-center md:items-start gap-8">
        <div class="md:w-1/2 text-center md:text-left">
          <i class="fa-solid fa-handshake text-4xl text-yellow-500 mb-4"></i>
          <h3 class="text-xl font-semibold mb-2">A Much Better Service</h3>
          <p class="text-gray-700">
            You can talk to us directly. We’ll help you set up your project and offer support in
            advertising, logistics, and more to make your launch smoother.
          </p>
        </div>
      </div>

      <div class="flex flex-col md:flex-row items-center md:items-start gap-8">
        <div class="md:w-1/2 text-center md:text-left">
          <i class="fa-solid fa-truck text-4xl text-yellow-500 mb-4"></i>
          <h3 class="text-xl font-semibold mb-2">Logistics and Customer Support</h3>
          <p class="text-gray-700">
            We provide logistics and customer support (optional add-ons) so you can focus on creating great products
            while we handle deliveries and customer communication.
          </p>
        </div>
      </div>

      <div class="flex flex-col md:flex-row-reverse items-center md:items-start gap-8">
        <div class="md:w-1/2 text-center md:text-left">
          <i class="fa-solid fa-industry text-4xl text-yellow-500 mb-4"></i>
          <h3 class="text-xl font-semibold mb-2">Production</h3>
          <p class="text-gray-700">
            If you already have production facilities lined up — great. If not, we’ll help you
            organize cost-efficient manufacturing in Asia, Europe, or the USA.
          </p>
        </div>
      </div>

      <div class="flex flex-col md:flex-row items-center md:items-start gap-8">
        <div class="md:w-1/2 text-center md:text-left">
          <i class="fa-solid fa-chart-line text-4xl text-yellow-500 mb-4"></i>
          <h3 class="text-xl font-semibold mb-2">Ongoing Sales</h3>
          <p class="text-gray-700">
            CleverDeals helps you smoothly transition from a pre-sale or launch project into ongoing sales — keeping
            your momentum and turning your idea into a real business.
          </p>
        </div>
      </div>

      <div class="flex flex-col md:flex-row-reverse items-center md:items-start gap-8">
        <div class="md:w-1/2 text-center md:text-left">
          <i class="fa-solid fa-users text-4xl text-yellow-500 mb-4"></i>
          <h3 class="text-xl font-semibold mb-2">Customer Trust</h3>
          <p class="text-gray-700">
            We’ll collaborate closely before launch to ensure reliable delivery and maintain
            customer confidence — avoiding the issues that hurt other crowdfunding platforms.
          </p>
        </div>
      </div>
    </section>

    <p class="mt-12">
      The involvement of founders in the process of finding customers for a new
      product and persuading them to hand over their hard earned cash is vital -
      we can't do it all for you but we can take a lot of the load, especially
      the parts that we know best like answering customer emails and organizing
      transportation and delivery.
    </p>

    <p class="mt-4">
      If you are interested in learning more about how CleverDeals could help
      you with your project, you can e-mail me directly
      <a href="mailto:roger&#64;cleverdeals.net" class="text-blue-600 underline">roger&#64;cleverdeals.net</a>
      – let’s talk.
    </p>
  </div>
</div>